import { ProgressReportPreviewInterface, Summary } from "@/src/models/IProgress";
import { FacilityInterface } from "@/src/models/IShowUser";
import { Flex } from "antd";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, Rectangle, ResponsiveContainer, Tooltip, TooltipProps, XAxis, YAxis } from "recharts";


const CustomTooltip = ({ active, payload, label }: TooltipProps<number, string>) => {
  if (active && payload && payload.length > 0) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: '#fff',
          padding: '10px',
          border: '1px solid #ccc',
          borderRadius: '8px',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        <p className="label" style={{ fontWeight: 'bold', marginBottom: '5px' }}>{`หมวดหมู่: ${label}`}</p>
        {payload[0] && (
          <p style={{ color: '#8884d8' }}>{`จำนวนงบประมาณที่ถูกยื่นขอ: ${Number(payload[0].value).toLocaleString()} บาท`}</p>
        )}
        {payload[1] && (
          <p style={{ color: '#82ca9d' }}>{`จำนวนงบประมาณที่ถูกใช้ไป: ${Number(payload[1].value).toLocaleString()} บาท`}</p>
        )}
      </div>
    );
  }

  return null;
};


const filterByMonth = (data: any[], month: number) => {
    return data.filter((item) => {
      const itemMonth = moment(item.SentBy).month() ;
      return itemMonth === month;
    });
  };

export function StaffReportDashboard(){
    const [summary_data,setSummarydata]=useState<Summary[]>([]);
    const [fac_summary_data,setFacSummarydata]=useState<Summary[]>([]);
    const [fac_budget_data,setFacBudgetData]=useState<Summary[]>([]);
    const [ProgressReportList,setProgresslist] = useState<ProgressReportPreviewInterface[]>([])
    const [Fac,setFac] = useState<FacilityInterface[]>([]);
    
    const months = [
      'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
      'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];

    const CustomTooltip = ({ active, payload, label }: TooltipProps<number, string>) => {
        if (active && payload && payload.length > 0) {
          return (
            <div
              className="custom-tooltip"
              style={{
                backgroundColor: '#fff',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '8px',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
              }}
            >
              <p className="label" style={{ fontWeight: 'bold', marginBottom: '5px' }}>{`หมวดหมู่: ${label}`}</p>
              {payload[0] && (
                <p style={{ color: '#8884d8' }}>{`ยอดทุนที่ขอ: ${Number(payload[0].value).toLocaleString()} บาท`}</p>
              )}
              {payload[1] && (
                <p style={{ color: '#82ca9d' }}>{`ยอดทุนที่ได้รับ: ${Number(payload[1].value).toLocaleString()} บาท`}</p>
              )}
            </div>
          );
        }
      
        return null;
      };

    const getData = async() =>{
        axios.get(`${process.env.REACT_APP_BASE}/GetProgressList`).then(async response=>{
            if(response.status==200){
                console.log(response.data)

                setProgresslist(response.data)

                console.log(response.data.length)

                const currentMonth = new Date().getMonth();

                const reorderedMonths = months
                .slice(currentMonth + 1) // Get the months from the next month onward
                .concat(months.slice(0, currentMonth + 1));
                let monthlySummary = reorderedMonths.map((month, index) => ({
                    name: month,
                    จำนวนโครงการที่ยื่นในระบบ: 0,
                    จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ:0,
                    จำนวนนักวิจัยที่ยื่นรายงานความก้าวหน้าในระบบ:0,
                    โครงการที่ถูกยื่นขอปิดโครงการ:0,
                    จำนวนนักวิจัยที่ยื่นขอปิดโครงการ:0,
                    จำนวนโครงการที่ปิดไปแล้ว:0,
                    จำนวนงบประมาณที่ถูกยื่นขอ:0,
                    จำนวนงบประมาณที่ถูกใช้ไป:0,
                  }));

                  for(let i = 0;i<12;i++){
                    const index = reorderedMonths.indexOf(months[i])
                    const Projects = filterByMonth(response.data, i);     
                    console.log(Projects) 
                    const Projectsent = Projects.filter((item)=>item.IsCompletion=="FALSE")
                    monthlySummary[index].จำนวนโครงการที่ยื่นในระบบ = Projectsent.length
                    monthlySummary[index].จำนวนนักวิจัยที่ยื่นรายงานความก้าวหน้าในระบบ = Array.from(
                        new Set(Projectsent.map((item) => item.head_name_th 
                        ))
                      ).filter((headResearcher) => headResearcher).length
                    const CompletionProjectsent = Projects.filter((item)=>item.IsCompletion=='TRUE')
                    monthlySummary[index].โครงการที่ถูกยื่นขอปิดโครงการ = CompletionProjectsent.length
                    monthlySummary[index].จำนวนนักวิจัยที่ยื่นขอปิดโครงการ = Array.from(
                        new Set(CompletionProjectsent.map((item) => item.head_name_th 
                        ))
                      ).filter((headResearcher) => headResearcher).length
                    monthlySummary[index].จำนวนโครงการที่ปิดไปแล้ว = Projects.filter((item) => {
                      return item.IsCompletion === 'TRUE' &&
                              item.ReportStatus === 'อนุมัติ';
                  }).length;
                }

                getCompletionReport(monthlySummary);

                console.log(monthlySummary)
                setSummarydata(monthlySummary)

                await axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_faculty.php`).then((res) => {
                    if(res.status==200){
                    setFac(res.data.filter((fac: any) => fac.Fac_ID !== "70"));
                  
                    // Extract unique Fac_IDs from the correct response data
                    const uniqueFacIDs = Array.from(new Set(response.data.map((item: { Fac_ID: any }) => item.Fac_ID)));
                    // Map uniqueFacIDs to create the summary
                    const FacSum = uniqueFacIDs.map((Fac_ID) => {
                      const faculty = res.data.filter((item:any) => item.Fac_ID==Fac_ID);
                      let x = response.data
                      return {
                        name: faculty[0]?.Fac_NameTH || Fac_ID, // Access the first element of the array
                        จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ: response.data.filter((item: any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='FALSE').length,
                        จำนวนนักวิจัยที่ยื่นรายงานความก้าวหน้าในระบบ: Array.from(
                          new Set(
                            response.data
                              .filter((item: any) => item.Fac_ID == Fac_ID&&item.IsCompletion=='FALSE')
                              .map((item: any) => item.head_researcher)
                          )
                        ).length,
                        โครงการที่ถูกยื่นขอปิดโครงการ: x.filter((item: {
                          IsCompletion: string;
                          project_status: string; Fac_ID: unknown; 
                          })=>item.Fac_ID == Fac_ID &&item.IsCompletion=='TRUE').length,
                        
                        จำนวนนักวิจัยที่ยื่นขอปิดโครงการ: x.filter((item: {
                          project_status: string; Fac_ID: unknown; 
                          })=>item.Fac_ID == Fac_ID && item.project_status == `ไม่อนุมัติ`).length,
                          ยอดทุนที่ได้รับ: x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce(
                          (sum: any, item: { AllSum: any; }) => sum + (item.AllSum || 0), 
                          0
                        ),
                        จำนวนโครงการที่ปิดไปแล้ว: x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce(
                          (sum: any, item: { AllSumHis: any; }) => sum + (item.AllSumHis || 0), 
                          0
                        ),
                        จำนวนงบประมาณที่ถูกยื่นขอ : x.filter((item:any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='TRUE').reduce((sum: number, item: any) => sum + (item.BUDGET || 0), 0),
                        จำนวนงบประมาณที่ถูกใช้ไป : x.filter((item:any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='TRUE').reduce((sum: number, item: any) => sum + (item.SPENT || 0), 0),
                      };
                    });

                  console.log(FacSum)
                  setFacSummarydata(FacSum)
                  }
                  });
            }}
        )
    }

    const getCompletionReport = async(tmp:any) => {
      axios.get(`${process.env.REACT_APP_BASE}/GetCompletion`).then(async response=>{
        if(response.status==200){
          const currentMonth = new Date().getMonth();

          await axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_faculty.php`).then((res) => {
            if(res.status==200){
              setFac(res.data.filter((fac: any) => fac.Fac_ID !== "70"));
              const uniqueFacIDs = Array.from(new Set(response.data.map((item: { Fac_ID: any }) => item.Fac_ID)));

              const FacSum = uniqueFacIDs.map((Fac_ID) => {
                const faculty = res.data.filter((item:any) => item.Fac_ID==Fac_ID);
                let x = response.data
                return {
                  name: faculty[0]?.Fac_NameTH || Fac_ID, // Access the first element of the array
                  จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ: response.data.filter((item: any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='FALSE').length,
                  จำนวนนักวิจัยที่ยื่นรายงานความก้าวหน้าในระบบ: Array.from(
                    new Set(
                      response.data
                        .filter((item: any) => item.Fac_ID == Fac_ID&&item.IsCompletion=='FALSE')
                        .map((item: any) => item.head_researcher)
                    )
                  ).length,
                  โครงการที่ถูกยื่นขอปิดโครงการ: x.filter((item: {
                    IsCompletion: string;
                    project_status: string; Fac_ID: unknown; 
                    })=>item.Fac_ID == Fac_ID &&item.IsCompletion=='TRUE').length,
                  
                  จำนวนนักวิจัยที่ยื่นขอปิดโครงการ: x.filter((item: {
                    project_status: string; Fac_ID: unknown; 
                    })=>item.Fac_ID == Fac_ID && item.project_status == `ไม่อนุมัติ`).length,
                    ยอดทุนที่ได้รับ: x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce(
                    (sum: any, item: { AllSum: any; }) => sum + (item.AllSum || 0), 
                    0
                  ),
                  จำนวนโครงการที่ปิดไปแล้ว: x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce(
                    (sum: any, item: { AllSumHis: any; }) => sum + (item.AllSumHis || 0), 
                    0
                  ),
                  จำนวนงบประมาณที่ถูกยื่นขอ : x.filter((item:any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='TRUE').reduce((sum: number, item: any) => sum + (item.BUDGET || 0), 0),
                  จำนวนงบประมาณที่ถูกใช้ไป : x.filter((item:any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='TRUE').reduce((sum: number, item: any) => sum + (item.SPENT || 0), 0),
                };
              });

              console.log(FacSum)
              setFacBudgetData(FacSum)
            }
          })

          
        }
      })
    }

    useEffect(()=>{
        getData();
      sessionStorage.setItem("project_id",``)
    },[]);
    return(
        <> 
            <h1 className='font-semibold text-3xl'>แดชบอร์ดรายงานความคืบหน้า</h1>
            <Flex justify='center'>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={summary_data}>
                    <XAxis dataKey="name" />
                        <YAxis allowDecimals={false}/>
                        <Tooltip />
                        <Legend />
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <Line type="monotone" dataKey="จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ" stroke="#8884d8" />
                        <Line type="monotone" dataKey="จำนวนนักวิจัยที่ยื่นรายงานความก้าวหน้าในระบบ" stroke="blue" />
                        <Line type="monotone" dataKey="โครงการที่ถูกยื่นขอปิดโครงการ" stroke="#82ca9d" />
                        <Line type="monotone" dataKey="จำนวนนักวิจัยที่ยื่นขอปิดโครงการ" stroke="#82ca9d" />
                        <Line type="monotone" dataKey="จำนวนโครงการที่ปิดไปแล้ว" stroke="red" />
                    </LineChart>
                </ResponsiveContainer>
            </Flex>
            <h1 className='font-semibold text-3xl'>แดชบอร์ดรายงานความคืบหน้าแต่ละแผนก</h1>
            <Flex justify='center'>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={fac_summary_data}>
                    <XAxis dataKey="name" />
                    <YAxis allowDecimals={false}/>
                    <Tooltip/>
                    <Legend />
                    <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                    <Bar onClick={(item)=>console.log(item.payload)} dataKey="จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} />
                    <Bar dataKey="จำนวนนักวิจัยที่ยื่นรายงานความก้าวหน้าในระบบ" fill="pink" activeBar={<Rectangle fill="gold" stroke="purple" />} />
                    <Bar dataKey="จำนวนโครงการที่ปิดไปแล้ว" fill="#82ca9d" activeBar={<Rectangle fill="orange" stroke="yellow" />} />
                </BarChart>
            </ResponsiveContainer>
            </Flex>
          <h1 className='font-semibold text-3xl'>ทุนที่ยื่นขอมาและใช้ไป</h1>
          <Flex justify='center'>
            <ResponsiveContainer width="100%" height={300}>
            <BarChart data={fac_budget_data}>
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip  content={<CustomTooltip />}/>
                <Legend />
                <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                <Bar dataKey="จำนวนงบประมาณที่ถูกยื่นขอ" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} />
                <Bar dataKey="จำนวนงบประมาณที่ถูกใช้ไป" fill="#82ca9d" activeBar={<Rectangle fill="gold" stroke="purple" />} />
                </BarChart>
            </ResponsiveContainer>
          </Flex>

        </>
    )
}